import { render } from "./tariffsWidget.vue?vue&type=template&id=00bb145d"
import script from "./tariffsWidget.vue?vue&type=script&lang=js"
export * from "./tariffsWidget.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./tariffsWidget.vue?vue&type=style&index=0&id=00bb145d&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__